module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-7.bd9d807e.jpg";